import { createContext, useContext, useEffect, useState } from "react";
import { api, storeAuth, clearAuth, getStoredUser, getToken } from "../lib/api";

const AuthCtx = createContext(null);

export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const u = getStoredUser();
    return u && getToken() ? u : null;
  });
  const [checking, setChecking] = useState(() => Boolean(getToken()));

  // Validate the stored token against the live backend on load
  useEffect(() => {
    if (!getToken()) return;
    api("/auth/me", { auth: true })
      .then((u) => {
        storeAuth(getToken(), u);
        setUser(u);
      })
      .catch((e) => {
        if (e.status === 401) {
          clearAuth();
          setUser(null);
        }
      })
      .finally(() => setChecking(false));
  }, []);

  const applyAuth = (data) => {
    storeAuth(data.access_token, data.user);
    setUser(data.user);
    return data.user;
  };

  const login = (email, password) =>
    api("/auth/login", { method: "POST", body: { email: String(email).toLowerCase(), password } }).then(applyAuth);

  const register = (payload) =>
    api("/auth/register", { method: "POST", body: { ...payload, email: String(payload.email).toLowerCase() } }).then(applyAuth);

  const logout = () => {
    clearAuth();
    setUser(null);
  };

  const value = {
    user,
    token: user ? getToken() : null,
    checking,
    login,
    register,
    logout,
    isSeller: user?.role === "seller",
  };
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}
